import ontarioCanadaMap from './ontario-canada-map.svg';
import fallbackBanner from './fallback-banner-mini.webp';

export default {
  ontarioCanadaMap,
  fallbackBanner,
};
